export default {"src":"/_next/static/media/globe.59c47749.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};